import { render, staticRenderFns } from "./TaskListOverview.vue?vue&type=template&id=41307de2&scoped=true"
import script from "./TaskListOverview.vue?vue&type=script&lang=js"
export * from "./TaskListOverview.vue?vue&type=script&lang=js"
import style0 from "./TaskListOverview.vue?vue&type=style&index=0&id=41307de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41307de2",
  null
  
)

export default component.exports